module.exports = __webpack_public_path__ + "img/whitelogo.c3a9536d.png";